import { Component, Input, OnInit } from '@angular/core';
import { parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

@Component({
  selector: 'cc-flag-number-item',
  templateUrl: './flag-number-item.component.html',
  styleUrls: ['./flag-number-item.component.scss'],
})
export class FlagNumberItemComponent implements OnInit {
  @Input() number: string;
  @Input() label: string;
  @Input() empty: string;
  formattedNumber: string;

  constructor() {}

  ngOnInit() {
    if (this.number.startsWith('webcall')) {
      this.formattedNumber = this.number;
    } else {
      this.formattedNumber = this.number ? parsePhoneNumber(this.number).formatInternational() : '';
    }
  }

  getNumbersCountry(phoneNumber: string) {
    const parsedNumber = phoneNumber && parsePhoneNumberFromString(phoneNumber.toString());
    return (
      parsedNumber && parsedNumber.country && parsedNumber.country.toLowerCase && parsedNumber.country.toLowerCase()
    );
  }

  getNumberFormat(phoneNumber: string) {
    if (this.getNumbersCountry(phoneNumber) === 'us') {
      return parsePhoneNumberFromString(phoneNumber.toString()).formatNational();
    } else {
      return parsePhoneNumberFromString(phoneNumber.toString()).formatInternational();
    }
  }
}
